export default __webpack_public_path__ + "static/Денежный поток 5-4f7ff6b81f56f1d3147a41b494b32615.jpg";